import { render, staticRenderFns } from "./zDialogoIntervaloData.vue?vue&type=template&id=5d904456&scoped=true&"
import script from "./zDialogoIntervaloData.vue?vue&type=script&lang=js&"
export * from "./zDialogoIntervaloData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d904456",
  null
  
)

export default component.exports